import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchConfiguracoes, fetchRecuperarAcesso } from '../../api/endpoints';
import { getTotem } from '../../api/apiFactory';
import { selectCidade } from '../../app/slices/cidadesSlice';
import {
  desfazerConexao, fetchLogin, fetchLoginAnonimo, selectLogin,
} from '../../app/slices/loginSlice';
import {
  abrirModalAnonimo,
  abrirModalLogin, abrirModalTotemLogin, fecharModalEscolhaLoginTotem, fecharModalLogin, fecharModalTotemLogin, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria } from '../../app/slices/secretariasSlice';
import {
  BreadCumbs,
  Container,
  ContainerJanela, ContainerTotem, Divisor, FormFooter, GridTotem, Linha,
} from '../../styles/base';
import Botao from '../../components/Botao/Botao';
import { espacamento } from '../../styles/constants/sizes';
import GridBotao from '../../components/GridBotao/GridBotao';
import Carregar from '../../components/Carregar/Carregar';

const EscolhaLogin = ({
  ouvidoria, sic, zeladoria, acompanhamento, cadastro,
}) => {
  const [carregando, setCarregando] = useState(false);
  const [carregandoAnonimo, setCarregandoAnonimo] = useState(false);
  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);
  const history = useHistory();

  // Propriedade criada para costantemente testar ser as configurações da cidades não foram mudadas, pois pode acontecer de setarem como não permitido login anonimo
  // enquanto o usuário está logado, e como a propriedade "dadosCidade" é cacheada, o usuário só pegaria os novos dados caso deslogasse da cidade.
  // Para evitar isso, utilizo a propriedade abaixo que testa as configurações da cidade sempre que adentra na página.
  const [verificarMudancaAnominoCidade, setVerificarMudancaAnominoCidade] = useState();

  useEffect(() => {
    if (acompanhamento
      && ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N')
        || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'N')
        || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'N'))) {
      if (ouvidoria) {
        history.push('/totem/ouvidoria/acompanhamento/login');
      }

      if (sic) {
        history.push('/totem/sic/acompanhamento/login');
      }

      if (zeladoria) {
        history.push('/totem/zeladoria/acompanhamento/login');
      }
    }

    fetchConfiguracoes().then((response) => setVerificarMudancaAnominoCidade(response));
  }, []);

  const entrarLogado = () => {
    if (acompanhamento) {
      if (ouvidoria) {
        history.push('/totem/ouvidoria/acompanhamento/login');
      }

      if (sic) {
        history.push('/totem/sic/acompanhamento/login');
      }

      if (zeladoria) {
        history.push('/totem/zeladoria/acompanhamento/login');
      }
    }

    if (cadastro) {
      if (ouvidoria) {
        history.push('/totem/ouvidoria/cadastrar/login');
      }

      if (sic) {
        history.push('/totem/sic/cadastrar/login');
      }

      if (zeladoria) {
        history.push('/totem/zeladoria/cadastrar/login');
      }
    }
  };

  const cadastrar = () => {
    if (history && history.location && history.location.pathname && history.location.pathname.includes('ouvidoria')) {
      history.push({
        pathname: '/totem/ouvidoria/conta',
        props: history && history.location && history.location.props,
      });
    }

    if (history && history.location && history.location.pathname && history.location.pathname.includes('sic')) {
      history.push({
        pathname: '/totem/sic/conta',
        props: history && history.location && history.location.props,
      });
    }

    if (history && history.location && history.location.pathname && history.location.pathname.includes('zeladoria')) {
      history.push({
        pathname: '/totem/zeladoria/conta',
        props: history && history.location && history.location.props,
      });
    }
  };

  const handleVoltar = () => {
    if (ouvidoria) {
      history.push('/totem/ouvidoria');
    }

    if (sic) {
      history.push('/totem/sic');
    }

    if (zeladoria) {
      history.push('/totem/zeladoria');
    }
  };

  const entrarAnonimo = async () => {
    if (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N') {
      dispatch(abrirModalAnonimo());
    }
    setCarregandoAnonimo(true);
    if (ouvidoria) {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'o',
      }));

      setCarregandoAnonimo(false);

      if (acompanhamento) {
        history.push('/totem/ouvidoria/acompanhamento');
      }

      if (cadastro) {
        history.push('/totem/ouvidoria/cadastrar');
      }
    }

    if (sic) {
      await dispatch(await fetchLoginAnonimo({
        modulo: 's',
      }));

      setCarregandoAnonimo(false);

      if (acompanhamento) {
        history.push('/totem/sic/acompanhamento');
      }

      if (cadastro) {
        history.push('/totem/sic/cadastrar');
      }
    }

    if (zeladoria) {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'z',
      }));

      setCarregandoAnonimo(false);

      if (acompanhamento) {
        history.push('/totem/zeladoria/acompanhamento');
      }

      if (cadastro) {
        history.push('/totem/zeladoria/cadastrar');
      }
    }
  };

  return (
    <>
      <BreadCumbs>
        Você está em:
        {' '}
        {(ouvidoria) && (<span style={{ fontWeight: 'bold' }}>Ouvidoria</span>)}
        {(sic) && (<span style={{ fontWeight: 'bold' }}>Pedido de Informação (e-SIC)</span>)}
        {(zeladoria) && (<span style={{ fontWeight: 'bold' }}>Zeladoria</span>)}
        {' '}
        &rsaquo;
        {' '}
        <span style={{ fontWeight: 'bold' }}>Autenticar</span>
      </BreadCumbs>
      <ContainerTotem>
        <Botao
          voltar
          label="Voltar"
          style={{
            marginRight: espacamento.pequeno, fontSize: 25, flex: 'unset',
          }}
          onClick={() => handleVoltar()}
        />
        <Container style={{ padding: 10 }}>
          <GridTotem>
            {!acompanhamento && (
              <GridBotao
                totem
                selecao
                key="OuviCadastrardoria"
                label="Criar usuário e senha"
                onClick={() => cadastrar()}
                img="https://eouve.com.br/svg_icons/dark/cadastrar_line.svg"
                size={14}
                imgWidth={50}
                imgHeight={50}
                cor="#cfa6ce"
              />
            )}
            <GridBotao
              selecao
              totem
              key="Entrar"
              label="Entrar com meu usuário e senha"
              img="https://eouve.com.br/svg_icons/dark/login_.svg"
              size={14}
              imgWidth={50}
              imgHeight={50}
              onClick={() => entrarLogado()}
              cor="#5e9cea"
            />
            {/* {((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S' && ouvidoria) || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'S' && sic)) && (!carregandoAnonimo) && ( */}
            {((verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoOuvidoria === 'S' && ouvidoria) || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoSic === 'S' && sic) || (verificarMudancaAnominoCidade && verificarMudancaAnominoCidade.OcultarAnonimoZeladoria === 'S' && zeladoria)) && (!carregandoAnonimo) && (
              <GridBotao
                totem
                selecao
                key="Anônimo"
                label="Continuar como anônimo"
                onClick={entrarAnonimo}
                img="https://eouve.com.br/svg_icons/dark/entrar_anonimo.svg"
                size={14}
                imgWidth={50}
                imgHeight={50}
                cor="#acb1bf"
              />
            )}
            {((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoSic === 'S') || (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S')) && (carregandoAnonimo) && (
              <Carregar anonimoTotem />
            )}
          </GridTotem>
        </Container>

      </ContainerTotem>
    </>
  );
};

EscolhaLogin.propTypes = {
  ouvidoria: PropTypes.bool,
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
  acompanhamento: PropTypes.bool,
  cadastro: PropTypes.bool,
};

EscolhaLogin.defaultProps = {
  ouvidoria: false,
  sic: false,
  zeladoria: false,
  acompanhamento: false,
  cadastro: false,
};

export default EscolhaLogin;
